export const normalizePhonePrefix = inputValue =>
    inputValue.startsWith('+') ? inputValue : `+${inputValue}`;

export const displayPhoneNumber = (phone, phonePrefix, legacyPhone) => {
    if (phone) {
        return `${phonePrefix}${phone}`;
    }
    return legacyPhone || '';
};
